export default __webpack_public_path__ + "static/media/gauge_100.839ff644.svg";